<template>
  <!-- star -->
  <div class="camo_wrap">
    <navigation></navigation>

    <!-- camo device detail -->
    <div class="camo">
      <!--top-->
      <div class="camo-top">
        <div class="camo-top-left">
          <div class="camo-top-left-arrow" @click="handleClick()"></div>
          <div class="camo-top-left-content">
            <div class="left-item" @mouseover="onHover(1)" :class="{ active: currentIndex === 1 }">
              <div class="img_div"><img src="../../assets/img/pieces/eye_mini.png"></div>
            </div>
            <div class="left-item2" @mouseover="onHover(2)" :class="{ active: currentIndex === 2 }">
              <div class="img_div2"><img src="../../assets/img/pieces/eye_mini.png"></div>
            </div>
          </div>
          <div class="camo-top-left-arrow2" @click="handleClick2()"></div>
        </div>
        <div class="camo-top-center" v-show="currentIndex==1">
          <img src="../../assets/img/pieces/eye_max.png">
        </div>
        <div class="camo-top-center" v-show="currentIndex==2">
          <img src="../../assets/img/pieces/eye_max.png">
        </div>
        <div class="camo-top-right">
          <h2>智能眼部按摩仪</h2>
          <div class="camo-top-right-content">
            <p>产品信息</p>
            <div class="right-item">
              <h2>服&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;务</h2>
              <div class="right-item1">
                <img src="../../assets/img/pieces/delivery.png">
                <span>货到付款</span>
              </div>
              <div class="right-item2">
                <img src="../../assets/img/pieces/freight.png">
                <span>免运费</span>
              </div>
              <div class="right-item3">
                <img src="../../assets/img/pieces/sf-express.png">
                <span>顺丰配送</span>
              </div>
            </div>
            <div class="right-item4">
              <h2>库存情况</h2>
              <span>下订单后30天以上货到仓库</span>
            </div>
          </div>
        </div>
      </div>

      <!--center-->
      <div class="camo-center">
        <div class="camo-center-title">
          <h2>产品详情</h2>
          <div class="camo-center-line"></div>
          <div class="camo-center-line2"></div>
          <div class="camo-center-content">
            <div class="camo-center-item">
              <div class="camo-center-item_1">
                <h2>品牌</h2>
              </div>
              <div class="camo-center-item_2">
                <h2>奥佳华</h2>
              </div>
              <div class="camo-center-item_3">
                <h2>颜色</h2>
              </div>
              <div class="camo-center-item_4">
                <h2>黛蓝、星灰</h2>
              </div>
            </div>
            <div class="camo-center-item2">
              <div class="camo-center-item2_1">
                <h2>商品名称</h2>
              </div>
              <div class="camo-center-item2_2">
                <h2>智能眼部按摩仪</h2>
              </div>
              <div class="camo-center-item2_3">
                <h2>保修期</h2>
              </div>
              <div class="camo-center-item2_4">
                <h2>12个月</h2>
              </div>
            </div>
            <div class="camo-center-item3">
              <div class="camo-center-item3_1">
                <h2>型号</h2>
              </div>
              <div class="camo-center-item3_2">
                <h2>OG2526</h2>
              </div>
              <div class="camo-center-item3_3">
                <h2>包装清单</h2>
              </div>
              <div class="camo-center-item3_4">
                <h2>主机 说明书</h2>
              </div>
            </div>
            <div class="camo-center-item4">
              <div class="camo-center-item4_1">
                <h2>类别</h2>
              </div>
              <div class="camo-center-item4_2">
                <h2>眼部按摩仪</h2>
              </div>
              <div class="camo-center-item4_3">
                <h2>额定电压</h2>
              </div>
              <div class="camo-center-item4_4">
                <h2>3.7V</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--bottom-->
      <div class="camo-bottom">
        <img src="../../assets/img/pieces/eye_detail.png">
      </div>
    </div>

    <footer2></footer2>
    <!-- end -->
  </div>
</template>

<script>
import navigation from "../../components/nav2.vue";
import footer2 from "../../components/footer.vue"

export default {
  name: "service",
  components: {
    navigation,
    footer2
  },
  data() {
    return {
      currentIndex: 1,
    };
  },
  mounted() {

  },
  methods: {
    handleClick() {
      this.currentIndex--;
      if (this.currentIndex == 0) this.currentIndex = 2;
    },
    handleClick2() {
      this.currentIndex++;
      if (this.currentIndex == 3) this.currentIndex = 1;
    },
    onHover(value){
      this.currentIndex=value;
    }
  }
};
</script>
<style scoped>
/*=========================Reset_start==========================*/
/*去内外边距*/
html,
body {
  font-family: "微软雅黑", "宋体", Arail, Tabhoma;
  text-align: left;
}

/*字体 文本居左*/
ul {
  list-style: none;
}

/*去ul li 小点*/
img {
  border: 0 none;
}

/*img IE6 兼容问题*/
input,
select,
textarea {
  outline: 0;
}

/*去除点击蓝框*/
textarea {
  resize: none;
  overflow: auto;
}

/*锁定多行文本框大小 与文字超出出现滚动条*/
table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*表格边框合并 边框间距0*/
th,
strong,
var,
em {
  font-weight: normal;
  font-style: normal;
}

/*特殊文字粗细 样式显示正常*/
a {
  text-decoration: none;
}

/*a标签去下划线*/
.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
}

/*清浮动*/
a {
  color: #000000;
}

/*==========================Reset_End===========================*/
.camo_wrap {
  width: 100vw;
  margin: 0 auto;
  /*height: 1000px;*/
}

.camo {
  width: 100%;
  /*height: 1500px;*/
}

.camo-top {
  width: 1203px;
  height: 500px;
  margin: 0 auto;
  margin-top: 50px;
  display: flex;
}

.camo-top-left {
  width: 128px;
  height: 432px;
}

.camo-top-left-arrow {
  width: 128px;
  height: 46px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  background-image: url("../../assets/img/camodetail/arrow-up.png");
  background-size: contain;
}

.camo-top-left-arrow:hover {
  cursor: pointer;
}

.camo-top-left-arrow2 {
  width: 128px;
  height: 46px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  background-image: url("../../assets/img/camodetail/arrow-down.png");
  background-size: contain;
}

.camo-top-left-arrow2:hover {
  cursor: pointer;
}

.camo-top-left-content {
  width: 128px;
  height: 340px;
}

.left-item {
  margin: 0 auto;
  width: 60px;
  height: 54px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #BABABA;
  /*border-radius: 5px 5px 5px 5px;*/
  /*opacity: 1;*/
  /*border: 2px solid #202020;*/
}

.left-item.active {
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 2px solid #202020;
}

.img_div {
  width: 43px;
  height: 31px;
  margin: 0 auto;
  cursor: pointer;
}

.img_div img {
  width: 43px;
  height: 31px;
  padding-top: 12px;
}

.left-item2 {
  margin: 0 auto;
  margin-top: 10px;
  width: 60px;
  height: 54px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #BABABA;
}

.left-item2.active {
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 2px solid #202020;
}

.img_div2 {
  width: 43px;
  height: 31px;
  margin: 0 auto;
  cursor: pointer;
}

.img_div2 img {
  width: 43px;
  height: 31px;
  padding-top: 12px;
}

.left-item3 {
  margin: 0 auto;
  margin-top: 10px;
  width: 60px;
  height: 54px;
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 1px solid #BABABA;
}

.left-item3.active {
  border-radius: 5px 5px 5px 5px;
  opacity: 1;
  border: 2px solid #202020;
}

.img_div3 {
  width: 43px;
  height: 31px;
  margin: 0 auto;
}

.img_div3 img {
  width: 43px;
  height: 31px;
  padding-top: 12px;
}

.camo-top-center {
  width: 500px;
  height: 480px;
  margin-left: 50px;
}

.camo-top-center img {
  width: 472px;
  height: 450px;
}

.camo-top-right {
  width: 508px;
  height: 300px;
}

.camo-top-right h2 {
  width: 400px;
  height: 28px;
  font-size: 20px;
  padding-left: 60px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 600;
  color: #000000;
  line-height: 23px;
}

.camo-top-right-content {
  width: 400px;
  height: 200px;
}

.camo-top-right-content p {
  width: 70px;
  height: 20px;
  font-size: 14px;
  padding-left: 60px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #3D3D3D;
  line-height: 16px;
}

.right-item {
  width: 400px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  display: flex;
}

.right-item h2 {
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #5E5E5E;
  line-height: 20px;
  /*letter-spacing: 28px;*/
}

.right-item1 {
  width: 100px;
  height: 20px;
  margin-top: 13px;
  margin-left: 10px;
  /*background-color: black;*/
}

.right-item1 img {
  margin-left: 10px;
  width: 16px;
  height: 16px;
}

.right-item1 span {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
  position: absolute;
  padding-left: 10px;
}

.right-item2 {
  width: 90px;
  height: 20px;
  margin-top: 13px;
}

.right-item2 img {
  margin-left: 10px;
  width: 16px;
  height: 16px;
}

.right-item2 span {
  width: 56px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
  position: absolute;
  padding-left: 10px;
}

.right-item3 {
  width: 75px;
  height: 20px;
  margin-top: 13px;
}

.right-item3 img {
  margin-left: 10px;
  width: 16px;
  height: 16px;
}

.right-item3 span {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
  position: absolute;
  padding-left: 10px;
}

.right-item4 {
  width: 400px;
  height: 50px;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  display: flex;
}

.right-item4 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #5E5E5E;
  line-height: 20px;
  /*letter-spacing: 28px;*/
}

.right-item4 span {
  padding-top: 15px;
  padding-left: 20px;
  width: 200px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #222222;
  line-height: 16px;
}

.camo-center {
  width: 1300px;
  height: 350px;
  margin: 0 auto;
}

.camo-center-title {
  width: 1203px;
  height: 100px;
  margin: 0 auto;
}

.camo-center-title h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #000000;
  line-height: 16px;
}

.camo-center-line {
  width: 87px;
  height: 2px;
  background: #000000;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}

.camo-center-line2 {
  width: 1200px;
  height: 0px;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border: 1px solid #EDEDED;
}

.camo-center-content {
  margin-top: 20px;
  width: 1203px;
  height: 224px;
}

.camo-center-item {
  width: 1203px;
  height: 56px;
  display: flex;
  border: 1px solid #EFEFEF;
}

.camo-center-item_1 {
  width: 177px;
  height: 56px;
  background: #F8F8F8;
}

.camo-center-item_1 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin: 0 auto;
  margin-top: 20px;
}

.camo-center-item_2 {
  width: 425px;
  height: 56px;
  background: #FFFFFF;
}

.camo-center-item_2 h2 {
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 30px;
}

.camo-center-item_3 {
  width: 177px;
  height: 56px;
  background: #F8F8F8;
}

.camo-center-item_3 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin: 0 auto;
  margin-top: 20px;
}

.camo-center-item_4 {
  width: 425px;
  height: 56px;
  background: #FFFFFF;
}

.camo-center-item_4 h2 {
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 30px;
}

.camo-center-item2 {
  width: 1203px;
  height: 56px;
  display: flex;
  border: 1px solid #EFEFEF;
}

.camo-center-item2_1 {
  width: 177px;
  height: 56px;
  background: #F8F8F8;
}

.camo-center-item2_1 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin: 0 auto;
  margin-top: 20px;
}

.camo-center-item2_2 {
  width: 425px;
  height: 56px;
  background: #FFFFFF;
}

.camo-center-item2_2 h2 {
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 30px;
}

.camo-center-item2_3 {
  width: 177px;
  height: 56px;
  background: #F8F8F8;;
}

.camo-center-item2_3 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin: 0 auto;
  margin-top: 20px;
}

.camo-center-item2_4 {
  width: 425px;
  height: 56px;
  background: #FFFFFF;
}

.camo-center-item2_4 h2 {
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 30px;
}

.camo-center-item3 {
  width: 1203px;
  height: 56px;
  display: flex;
  border: 1px solid #EFEFEF;
}

.camo-center-item3_1 {
  width: 177px;
  height: 56px;
  background: #F8F8F8;
}

.camo-center-item3_1 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin: 0 auto;
  margin-top: 20px;
}

.camo-center-item3_2 {
  width: 425px;
  height: 56px;
  background: #FFFFFF;
}

.camo-center-item3_2 h2 {
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 30px;
}

.camo-center-item3_3 {
  width: 177px;
  height: 56px;
  background: #F8F8F8;;
}

.camo-center-item3_3 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin: 0 auto;
  margin-top: 20px;
}

.camo-center-item3_4 {
  width: 425px;
  height: 56px;
  background: #FFFFFF;
}

.camo-center-item3_4 h2 {
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 30px;
}

.camo-center-item4 {
  width: 1203px;
  height: 56px;
  display: flex;
  border: 1px solid #EFEFEF;
}

.camo-center-item4_1 {
  width: 177px;
  height: 56px;
  background: #F8F8F8;
}

.camo-center-item4_1 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin: 0 auto;
  margin-top: 20px;
}

.camo-center-item4_2 {
  width: 425px;
  height: 56px;
  background: #FFFFFF;
}

.camo-center-item4_2 h2 {
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 30px;
}

.camo-center-item4_3 {
  width: 177px;
  height: 56px;
  background: #F8F8F8;;
}

.camo-center-item4_3 h2 {
  width: 70px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 16px;
  margin: 0 auto;
  margin-top: 20px;
}

.camo-center-item4_4 {
  width: 425px;
  height: 56px;
  background: #FFFFFF;
}

.camo-center-item4_4 h2 {
  width: 280px;
  height: 20px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 16px;
  margin-top: 20px;
  margin-left: 30px;
}

.camo-bottom {
  width: 984px;
  height: 35383px;
  margin: 0 auto;
}

.camo-bottom img {
  width: 984px;
  height: 35383px;
}

</style>
